var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-input el-input--mini"},[_c('label',[_c('input',{staticClass:"el-input__inner",attrs:{"id":_vm.inputId},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})])])}
var staticRenderFns = []

export { render, staticRenderFns }